import axios from 'axios';
import { FETCH_DAIRIES_FAILURE, FETCH_DAIRIES_REQUEST, FETCH_DAIRIES_SUCCESS } from './actionTypes';

export function getDairiesBySlug(slug1, slug2) {
  return dispatch => {
    dispatch({ type: FETCH_DAIRIES_REQUEST });
    return axios({
      url: `${process.env.GATSBY_API_URL}/dairy/dairies?slug=${slug1},${slug2}&&thisweek=true`,
      method: 'get',
    })
      .then(response => {
        dispatch({ type: FETCH_DAIRIES_SUCCESS, payload: response.data });
      })
      .catch(error => {
        dispatch({ type: FETCH_DAIRIES_FAILURE, payload: error });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/DairiesAction.js